import { render, staticRenderFns } from "./HormonalHistory.vue?vue&type=template&id=1bce8006"
import script from "./HormonalHistory.vue?vue&type=script&lang=js"
export * from "./HormonalHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports